var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaste = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 21,
  viewBox: "0 0 16 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.33921 1.30388C4.4327 0.83646 4.84311 0.5 5.31979 0.5H10.6802C11.1569 0.5 11.5673 0.83646 11.6608 1.30388L11.7 1.5H13C14.6569 1.5 16 2.84315 16 4.5V17.5C16 19.1569 14.6569 20.5 13 20.5H3C1.34315 20.5 0 19.1569 0 17.5V4.5C0 2.84315 1.34315 1.5 3 1.5H4.29999L4.33921 1.30388ZM5.9396 3.5L6.1396 2.5H9.86038L10.0604 3.5H5.9396ZM12.1 3.5L12.2608 4.30388C12.3845 4.92267 11.9112 5.5 11.2802 5.5H4.71979C4.08875 5.5 3.61545 4.92268 3.73921 4.30388L3.89999 3.5H3C2.44772 3.5 2 3.94772 2 4.5V17.5C2 18.0523 2.44772 18.5 3 18.5H13C13.5523 18.5 14 18.0523 14 17.5V4.5C14 3.94772 13.5523 3.5 13 3.5H12.1Z",
  fill: "#FF8B22"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8387 8.28708C11.0206 8.10343 11.2683 8 11.527 8C11.7857 8 12.0335 8.1035 12.2154 8.28725C12.5952 8.66863 12.5949 9.27996 12.2143 9.66091L7.16221 14.7138C6.78101 15.0952 6.16382 15.0953 5.78268 14.7138L3.78566 12.7146C3.40514 12.3336 3.40478 11.7223 3.78459 11.341C3.96649 11.1572 4.21433 11.0537 4.47304 11.0537C4.73166 11.0537 4.97943 11.1571 5.16131 11.3408L6.47483 12.6557L10.8387 8.28708Z",
  fill: "#FF8B22"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaste);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paste.a039d5d97f619f5c092b5e5138690bc3.svg";